// src/firebase.js

import { initializeApp } from "firebase/app";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";

// .env dosyalarından gelen Firebase konfigürasyon bilgilerin
const firebaseConfig = {
  apiKey: process.env.REACT_APP_API_KEY,
  authDomain: process.env.REACT_APP_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_PROJECT_ID,
  storageBucket: process.env.REACT_APP_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_APP_ID,
};

// Firebase uygulamasını başlat
const app = initializeApp(firebaseConfig);

// Diğer servisleri export et
export const auth = getAuth(app);
export const db = getFirestore(app);

// Functions servisini doğru bölge ile başlat
export const functions = getFunctions(app, "europe-west3");

// --- EMULATOR MODU (yalnızca uçtan uca test için) ---
// Üretim derlemesinde REACT_APP_USE_EMULATOR tanımlı olmadığı için bu blok ÇALIŞMAZ.
// Açmak için (canlıya asla dokunmaz — proje kimliği "demo-" ile başlar):
//   npm run start:emu
export const emulatorModu = process.env.REACT_APP_USE_EMULATOR === "true";

if (emulatorModu) {
  const host = process.env.REACT_APP_EMULATOR_HOST || "127.0.0.1";
  connectAuthEmulator(auth, `http://${host}:9099`, { disableWarnings: true });
  connectFirestoreEmulator(db, host, 8080);
  connectFunctionsEmulator(functions, host, 5001);
  // eslint-disable-next-line no-console
  console.warn(
    `[EMULATOR MODU] Firestore/Auth/Functions ${host} üzerindeki emülatöre bağlandı. ` +
      `Proje: ${firebaseConfig.projectId}. Canlı veriye erişim YOK.`
  );
}